<template>
    <div class="main-container">
        <breadcrumb :list="breadcrumbList" />
        <div class="margintop-32" />
        <tl-header type="h1">Installments</tl-header>

        <search-dropdown
                style="margin-bottom: 20px;"
                placeholder="Search Employee"
                :employeeData="employeeData"
                :clearRequired="true"
                @getList="searchEmployeesByName($event)"
                @empselected="(emp) => selectedEmp(emp)"
              />
              <div v-if="showEmpDetails" class="employeeCard">
              <div class="empImage">
                <img
                  src="@/assets/user.svg"
                  class="employeeImage"
                  alt=""  
                />
              </div>
              <div class="employeeDetails">
                <div class="rowOneContent">
                  <div class="empDetails">
                    <div class="empContentdev">
                      <p class="empContent">Name:</p>
                      <p class="empContent">
                        <b>{{ EmployeeName }}</b>
                      </p>
                    </div>
                  </div>
                  <div class="rowOneContent">
                  <div class="empDetails">
                    <div class="empContentdev">
                      <p class="empContent">Employee Code:</p>
                      <p class="empContent">
                        <b>{{ EmployeeCode }}</b>
                      </p>
                    </div>
                  </div>
                  </div>
                  </div>
                  </div>
              </div>
              <div v-if="showEmpDetails" class="employeeCard">
                <div class="table-div" ref="table_div" >
                <data-table
                :columns="employeeTableColumns"
                :tableData="selectedEmployeeData"
                :showinrow="true"
                @editStart="false"
                :showedit="false"
                :with-form="false"
                :showhistory="false"
                :showdelete="false"
                >
                <template v-slot:rowcontent="slotprops">
                  <p v-if="slotprops.value.column.key !== 'is_perk' && slotprops.value.column.key !== 'status' && slotprops.value.column.key !== 'schedule_code'">
                    {{ slotprops.value.record[slotprops.value.column.key] }}
                  </p>
                  <p style='width:120px' v-if="slotprops.value.column.key == 'schedule_code'"> {{ slotprops.value.record.schedule_code }}</p>
                  <select
                  v-if="slotprops.value.column.key == 'status'"
                  v-model="slotprops.value.record.status"
                  class="selectDrop"
                  @change="updateStatus(slotprops.value.record)"
                >
                  <option>{{ slotprops.value.record[slotprops.value.column.key] }}</option>
                  <option v-for="option in getStatusOptions(slotprops.value.record[slotprops.value.column.key])" :key="option" :value="option">
                    {{ option }}
                  </option>
                </select>        
                <p v-if="slotprops.value.column.key == 'is_perk'">{{ formatPerkApplicable(slotprops.value.record.is_perk) }}</p>
              </template>
              </data-table>
              </div>
        </div>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters, mapState } from "vuex";
  export default {
    data() {
    return {
        navList:[],
        formate: "",
        EmployeeName:"",
        EmployeeCode:"",
        formateLess:"",
        toast: false,
        employeeTableColumns: [
        {
          label: "Shedule Code",
          key: "schedule_code"
        },
        {
          label: "Salary Component Code",
          key: "salary_component_code"
        },
        {
          label: "Principal Amount",
          key: "principal_amount"
        },
        {
          label: "Monthly Value",
          key: "monthly_value"
        },
        {
          label: "No Of Installments",
          key: "no_of_installments"
        },
        {
          label: "No Of Installments Remaining",
          key: "no_of_installments_remaining"
        },
        {
          label: "Effective Month",
          key: "effective_month"
        },
        {
          label: "Effective Year",
          key: "effective_year"
        },
        {
          label: "Perk Applicable",
          key: "is_perk"
        },
        { label: "Status", 
          key: "status", 
          slot: 'status' } 
      ],
        showEmpDetails: false,
        employeeData: [],
        schedeleCode:'',
        selectedEmployeeData:[],
        showUploadDocuments: false,
        employeeDocs: [],
        data: {},
        empId: null,
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Installments",
          url: ``
        }
      ],

    };
  },
  activated() {
    this.toast = false;
    this.errmsg = "";
    this.le = this.leId();
  },
  computed: {
    ...mapState("onboard/ctcslab", {
      ctcSlabsDataAll: (state) => state.entityWiseData,
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    leId() {
      //console.log("inside the leId");
      this. formate= new Intl.NumberFormat('en-in',{
        currency: "INR",
        style: "currency"
          });
       this.formateLess= new Intl.NumberFormat('en-in');
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
      
    },

    CTCslabID() {
      //console.log(this.leId);
      return this.ctcSlabsDataAll[this.leId];
    },
    requestParams() {
      return {
        leId: this.leId,
      };
    },
  },
  created:{
  },
  methods: {
    ...mapActions({
        fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
        fetchEmployeeInstallation: "globalapi/globalemployees/fetchByInstallation",
        fetchByInstallationStatus: "globalapi/globalemployees/fetchByInstallationStatus",
        fetchEmployeeDocumentsByEmployeeId:
        "dashboard/organisation/employeeDocument/fetchEmployeeByID",
    }),
    refresh() {
      try {
        this.showEmpDetails = false;
      }catch (error) {
        this.toast = true;
        this.errmsg = error;
      }},
  async searchEmployeesByName(val) {
      try {

        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.leId,
          key: val,
        });
        this.employeeData = res.data.payload;
        this.EmployeeName = res.data.payload[0].first_name
        this.EmployeeCode = res.data.payload[0].code
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    loadEmployeeDocuments(res) {
      let documentList = [];
    },
    async loadDocuments() {
      let res = await this.fetchEmployeeDocumentsByEmployeeId({
        data: { employee_id: this.empId },
      });
      this.employeeDocs = [];
      this.loadEmployeeDocuments(res);
      this.showUploadDocuments = !this.showUploadDocuments;
    },

    async selectedEmp(emp) {
      try {
        this.employeeDocs = [];
        this.data = emp;
        this.empId = emp.id;
        let res = await this.fetchEmployeeDocumentsByEmployeeId({
          data: { employee_id: emp.id },
        });
        this.fetchInstallation()
        this.loadEmployeeDocuments(res);
        this.showEmpDetails = true;
        this.fetchAllFbpLockDetails();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async fetchInstallation() {
      try {
        let res = await this.fetchEmployeeInstallation({
          data:{employee_id: this.empId, page: 1, limit: 10 }
        })
       
        this.selectedEmployeeData = res.data.payload
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async updateStatus(record) {
      try {
        let  payloadData = {
            employee_id: this.empId,
            status: record.status,
            schedule_code: record.schedule_code
        }
        let res = await this.fetchByInstallationStatus(payloadData);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    getStatusOptions(currentStatus) {
      const statusOptions = {
        ACTIVE: ['PAUSED', 'CLOSED'],
        PAUSED: ['CLOSED', 'ACTIVE'],
        CLOSED: ['PAUSED', 'ACTIVE'],
      };
      return statusOptions[currentStatus] || [];
    },
    formatPerkApplicable(value) {
      return value ? 'Yes' : 'No';
    }

}

  }
  </script>
  
  <style lang="scss" scoped>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  .selectDrop{
    width: 130px !important;
  }
  .employeeCard {
  background-color: #f0f1f5;
  display: flex;
}
.employeeImage {
  height: 8rem;
  width: 8rem;
  margin: 20px;
}
.employeeDetails {
  margin: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
}
.empDetails {
  background-color: white;
  width: 14rem;
  border-radius: 6px;
  box-shadow: #e5e7f8 2px 4px 3px;
}
.empContentdev {
  padding: 5px 12px;
  position: relative;
}
.empContent {
  margin-bottom:2px;
  font-size: 12px;
}
.rowOneContent {
  display: flex;
  gap: 12px;
}
  </style>
  